import React, { Component } from 'react';
import { styleStrings } from '../helpers/styles-core';

function Modal(props) {
  if (!props.isOpen) {
    return null;
  }
  return (
    <div className={styleStrings.modal.outer}>
      <div
        className={styleStrings.modal.shadow}
        onClick={props.onShadowClick}
      />
      <div
        className={styleStrings.modal.inner}
        style={{ maxWidth: props.maxWidth }}
      >
        {props.children}
      </div>
    </div>
  );
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components_new/Modal.js